<template>
  <DialogModal :show="show" :title="`${section?.name || 'Klausel'} bearbeiten`" @close-modal="$emit('close')">
    <FormKit type="form" :actions="false" @submit="submit">
      <TemplateVariable
        v-for="templateVariable in section.template_variables"
        :key="templateVariable.id"
        :template-variable="questionnaireStore.getTemplateVariable(templateVariable.code)"
        :show-info-text="false"
      >
      </TemplateVariable>
      <LSButton type="secondary">Speichern</LSButton>
    </FormKit>
  </DialogModal>
</template>

<script setup lang="ts">
import DialogModal from '@/components/DialogModal.vue'
import LSButton from '@/components/LSButton.vue'

import TemplateVariable from '@/questionnaire/components/TemplateVariable.vue'

import { useQuestionnaireStore } from '@/questionnaire/stores/questionnaire'
import type { LegalDocumentSection, TemplateVariableValue } from '@/questionnaire/types'

defineProps<{ section: LegalDocumentSection; show: boolean }>()
const emit = defineEmits<{ submit: [data: Record<string, TemplateVariableValue>]; close: [] }>()

// TODO: @paukul get rid of the dependency to the questionnaire store
const questionnaireStore = useQuestionnaireStore()

const submit = (data: Record<string, TemplateVariableValue>) => {
  emit('submit', data)
}
</script>
